import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SendTicketFriendModalComponent } from 'src/app/modals/send-ticket-friend-modal/send-ticket-friend-modal.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TicketsService } from 'src/app/services/tickets.service';

@Component({
  selector: 'app-tickets-access-page',
  templateUrl: './tickets-access-page.component.html',
  styleUrls: ['./tickets-access-page.component.scss'],
})
export class TicketsAccessPageComponent implements OnInit {
  tickets: any = [];

  butonStyleDisponible = '';
  butonStyleUsados = '';
  type: any;
  loading: any = true;

  constructor(
    private router: Router,
    private ticketsService: TicketsService,
    private route: ActivatedRoute,
    public modal: MatDialog
  ) {}

  ngOnInit() {
    let element = document.querySelector('.tittle-navbar') as HTMLElement;
    element.innerHTML = 'Tickets de Accesos';

    this.route.params.subscribe(async (params) => {
      this.tickets = [];
      this.loading = true;

      this.type = params['type'] || 'aproved';
      this.butonStyleDisponible = this.type === 'aproved' ? 'accent' : '';
      this.butonStyleUsados = this.type === 'used' ? 'accent' : '';

      (await this.ticketsService.getTicketsAccess(this.type)).subscribe(
        (data: any) => {
          if (data.result) {
            this.tickets = data.result;
          } else {
            alert('getTicketsAccess ' + data.message);
          }

          this.loading = false;
        }
      );
    });
  }

  async changeTypeTickets(type: string) {
    this.router.navigate([
      'tickets-access',
      {
        type: type,
      },
    ]);
  }

  sendTicket(ticket: any) {
    const dialogRef = this.modal.open(SendTicketFriendModalComponent, {
      data: { ticket },
      disableClose: true,
      width: '100vw',
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      console.log(result);
      if (result) {
        this.tickets = [];
        this.loading = true;

        console.log(this.type);

        (await this.ticketsService.getTicketsAccess(this.type)).subscribe(
          (data: any) => {
            console.log(data);
            if (data.result) {
              this.tickets = data.result;

              this.butonStyleDisponible = this.type === 'aproved' ? 'warn' : '';
              this.butonStyleUsados = this.type === 'used' ? 'warn' : '';
            } else {
              alert('getTicketsAccess ' + data.message);
            }

            this.loading = false;
          }
        );
      }
    });
  }
}
